import { MARKETS as r } from "@smart/types";
import { z as o } from "./index-Ct_QpAtH.mjs";
const s = o.object(
  Object.fromEntries(r.map((e) => [e, o.boolean().optional()]))
), i = o.object({
  enabledGlobally: o.boolean(),
  markets: s.optional()
});
function b(e, a) {
  const n = new Set(Object.keys(e));
  if (a.some(
    (t) => !n.has(t)
  ))
    throw new Error(
      `Invalid feature flags found in feature flags config. Used feature switches are: ${a.join(
        ", "
      )}`
    );
  return Object.values(e).forEach((t) => {
    i.parse(t);
  }), e;
}
export {
  b as v
};
//# sourceMappingURL=validate-feature-flags-config-O7ZXBX79.mjs.map
